import script from "./PhotoSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoSlider.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoSlider.vue?vue&type=style&index=0&id=77f6a1fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f6a1fa"]])

export default __exports__